import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Fab, Tooltip } from '@mui/material';
import { m, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';
import arrowIosUpwardFill from '@iconify/icons-eva/arrow-ios-upward-fill';

// config
import { HEADER, NAVBAR } from '../../config';

import { varZoom } from '../../components/animate';
import MenuNavigation from './MenuNavigation';

// ----------------------------------------------------------------------

const MainStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [showScrollToTopBtn, setShowScrollToTopBtn] = useState(false);
  const theme = useTheme();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleScroll = (e) => {
    setShowScrollToTopBtn(e.target.scrollingElement.scrollTop > 600);
  };

  return (
    <Box
      sx={{
        background: theme.palette.background.neutral,
      }}
    >
      <MainStyle
        sx={{
          backgroundImage: `url(/assets/img/cyan-blur.png), url(/assets/img/red-blur.png)`,
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundSize: '50%, 50%',
          backgroundPosition: 'right top, left bottom',
        }}
      >
        <Outlet />
      </MainStyle>
      <MenuNavigation />
      <AnimatePresence>
        {showScrollToTopBtn && (
          <Tooltip title="Scroll To Top" placement="left">
            <Fab
              component={m.div}
              {...varZoom({
                distance: 120,
                durationIn: 0.32,
                durationOut: 0.24,
                easeIn: 'easeInOut',
              }).in}
              sx={{
                position: 'fixed',
                right: '25px',
                bottom: '65px',
                zIndex: '1000000000 !important',
              }}
              variant="primary"
              size="medium"
              onClick={scrollToTop}
            >
              <Icon icon={arrowIosUpwardFill} width={24} height={24} />
            </Fab>
          </Tooltip>
        )}
      </AnimatePresence>
    </Box>
  );
}
